import { render, staticRenderFns } from "./GravitationalWaveViz.vue?vue&type=template&id=322199d7&scoped=true"
import script from "./GravitationalWaveViz.vue?vue&type=script&lang=js"
export * from "./GravitationalWaveViz.vue?vue&type=script&lang=js"
import style0 from "./GravitationalWaveViz.vue?vue&type=style&index=0&id=322199d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322199d7",
  null
  
)

export default component.exports